import React from 'react'
import ReactSelect from 'react-select'
import R from 'ramda'

const pullValues = R.pluck('value')

/**
 * This extends react-select with valueLink support
 * https://github.com/JedWatson/react-select/issues/256
 */
class SelectAjax extends React.Component {
  static propTypes = {
    handleOptions: React.PropTypes.func.isRequired,
    onChange: React.PropTypes.func,
    valueLink: React.PropTypes.object,
    multi: React.PropTypes.bool,
    value: React.PropTypes.any,
    options: React.PropTypes.any,
    url: React.PropTypes.string.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor (props, context) {
    super(props, context)
  }

  async handleChange (input, cb) {
    const { url, handleOptions, options } = this.props

    if (!input || input.length <= 2) {
      return cb(null, {
        options: options,
        completed: false
      })
    }

    const store = this.context.store
    if (Array.isArray(input)) return cb(null, { options: options, completed: true })

    const res = await store.get(url, {
      search: input,
      limit: 5
    })

    cb(null, {
      options: handleOptions(res.get('data')),
      completed: true
    })
  }

  onChange (singleValue, multiValues) {
    // Dispatch to caller onChange if present
    if (this.props.onChange) {
      this.props.onChange(singleValue, multiValues)
    }

    if (this.props.valueLink) {
      // Multi select: grab values and send array of values to valueLink
      if (this.props.multi) {
        this.props.valueLink.requestChange(pullValues(multiValues))
      }
      // Single select: send text value to valueLink
      else {
        this.props.valueLink.requestChange(singleValue)
      }
    }
  }

  render() {
    const { valueLink, ...other } = this.props
    let { value } = this.props

    value = value || (valueLink && valueLink.value) || ''
    if (value && value.toJS) value = value.toJS()

    return (
      <ReactSelect
        value={value}
        asyncOptions={::this.handleChange}
        onChange={::this.onChange}
        {...other}
      />
    )
  }
}

export default SelectAjax



// WEBPACK FOOTER //
// ./modules/shared/components/selectAjax.js